"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Category_1 = __importDefault(require("./Category"));
class SalesByCategorySummary {
    constructor({ category, value }) {
        this.toJSON = () => ({
            category: this.category,
            value: this.value,
        });
        this.category = category;
        this.value = value;
    }
}
SalesByCategorySummary.fromJSON = (json) => {
    const { category, value } = Object.assign({}, json);
    if (typeof value !== 'number')
        throw new Error('.value must be an number');
    const _category = Category_1.default.fromJSON(category);
    return new SalesByCategorySummary({
        category: _category,
        value,
    });
};
exports.default = SalesByCategorySummary;
